import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { LocationMap } from './LocationMap';
import { TypeformSurvey } from './TypeformSurvey';
import { Location, FormResponse, CombinedData } from '../types';
import '../styles/Survey.css';

export const SurveyContainer: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [formData, setFormData] = useState<FormResponse | null>(null);
  const [finalData, setFinalData] = useState<CombinedData | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState<string | null>(null);

  React.useEffect(() => {
    const postcode = searchParams.get('postcode');
    const streetNumber = searchParams.get('street_number');
    
    if (postcode && streetNumber) {
      setFormData({
        postcode: decodeURIComponent(postcode),
        streetNumber: decodeURIComponent(streetNumber)
      });
    }
  }, [searchParams]);

  const handleLocationConfirm = async (location: Location) => {
    if (!formData) return;

    const combinedData: CombinedData = {
      formData,
      location
    };
    
    setIsSubmitting(true);
    setSubmitError(null);

    try {

      const url =`${process.env.REACT_APP_API_URL}/api/submit-location`;
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(combinedData)
      });

      if (!response.ok) {
        throw new Error('Failed to submit location');
      }
      setFinalData(combinedData);
    } catch (error) {
      console.error('Error submitting location:', error);
      setSubmitError('Failed to submit location. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!formData) {
    return (
      <div className="survey-container">
        <TypeformSurvey />
      </div>
    );
  }

  if (finalData) {
    return (
      <div className="survey-container">
        <h2>Thank you!</h2>
        <p className="description">Your location has been submitted successfully.</p>
      </div>
    );
  }

  return (
    <div className="survey-container">
      <h2>Drop a pin on your roof</h2>
      <p className="description">
        We need to identify the roof of the property where we will perform the install.
      </p>
      <div className="map-container">
        <LocationMap
          postcode={formData.postcode}
          streetNumber={formData.streetNumber}
          onConfirm={handleLocationConfirm}
        />
      </div>
      {isSubmitting && <p className="loading">Submitting...</p>}
      {submitError && <p className="error">{submitError}</p>}
    </div>
  );
};

export default SurveyContainer; 